import type { NotifyFn, OpenDashboardOptions } from './types';

/**
 * Calls the admin partner-change endpoint with a JWT, then opens the returned
 * dashboard URL in a new tab.
 */
export const openDashboardForCandidate = async (
  url: string | null,
  notify: NotifyFn,
  options?: OpenDashboardOptions
): Promise<void> => {
  if (!url) return;

  const token = localStorage.getItem('access_token');

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    });

    if (response.ok) {
      const data = await response.json();
      if (data.redirect_url) {
        const redirectUrl = options?.transformRedirectUrl
          ? options.transformRedirectUrl(data.redirect_url)
          : data.redirect_url;
        window.open(redirectUrl, '_blank');
      }
      return;
    }

    const data = await response.json().catch(() => null);
    const message = data?.message || `Error ${response.status}: Unable to switch partner.`;
    notify(message, { type: 'warning' });
  } catch {
    notify('Network error: Unable to reach the API.', { type: 'warning' });
  }
};
